import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Иконка пункта меню. img — либо строка-URL (фирменный знак logo-mark.svg),
// либо объект Font Awesome. Растровые PNG 24×24 на плотности 3x растягивались
// втрое и выглядели мыльными (QA 08.26, №40) — меню переведено на вектор.
export function MenuIcon({ img, size = 22, style }) {
  if (!img) return null;
  const s = { display: "inline-flex", alignItems: "center", ...style };
  if (typeof img === "string")
    return (
      <img
        src={img}
        style={{ width: size, height: size, objectFit: "contain", ...s }}
      />
    );
  return (
    <span style={{ ...s, fontSize: size }}>
      <FontAwesomeIcon icon={img} style={{ width: size }} />
    </span>
  );
}
